module.exports = __webpack_public_path__ + "img/tv-music.02732d75.svg";